<template>
  <div class="mt-4">
    <SMSRecipientsPopup :isActive="isDetailsActive" @close="toggleDetails" />
    <!-- <h2 class="font-bold text-xl mb-6">SMS</h2> -->
    <div class="lg:flex md:flex items-center mb-4">
      <base-input
        class="lg:w-1/2 md:w-1/2 w-full lg:mr-2 md:mr-2"
        label="Campaign Name"
      >
        <b-input placeholder="Enter Campaign Name " />
      </base-input>
      <base-input
        class="lg:w-1/2 md:w-1/2 w-full lg:ml-2 md:ml-2"
        label="Enter Subject"
      >
        <!-- <select class="form-control">
          <option disabled="true">Please Create Senderid</option>
        </select> -->
        <b-input placeholder=" Enter Subject" />
      </base-input>
    </div>

    <div class="lg:flex md:flex items-center mb-4">
      <base-input
        class="lg:w-1/2 md:w-1/2 w-full lg:mr-2 md:mr-2"
        label="From SMS Address"
      >
        <b-input placeholder="Enter From SMS Address" />
      </base-input>

      <base-input
        class="lg:w-1/2 md:w-1/2 w-full lg:ml-2 md:ml-2"
        label="Reply to SMS Address (Optional)"
      >
        <b-input placeholder="Enter Reply to SMS Address" />
      </base-input>
    </div>
    <div class="mb-6">
      <b-form-group class="mb-4">
        <p class="font-semibold mb-4">Content</p>
        <b-form-radio
          v-model="content"
          class="custom-control-inline radio-btn-fix"
          name="some-radios"
          value="A"
          ><p class="font-semibold">Select Template</p></b-form-radio
        >
        <b-form-radio
          v-model="content"
          class="custom-control-inline radio-btn-fix"
          name="some-radios"
          value="B"
          ><p class="font-semibold">Via Editor</p></b-form-radio
        >
      </b-form-group>

      <div class="lg:w-1/2 w-full md:w-1/2 mb-4">
        <base-input label="Select Template" v-if="content === 'A'">
          <select class="form-control">
            <option disabled="true">Select Template</option>
            <option>Template 1</option>
            <option>Template 2</option>
          </select>
        </base-input>
      </div>

      <div v-if="content === 'B'" class="mb-4">
        <TextEditor />
      </div>
    </div>

    <div class="flex mb-4 items-center">
      <base-input
        class="lg:w-1/2 w-full md:w-1/2 lg:pr-3 md:pr-3"
        label="Attachment (Optional)"
      >
        <b-form-file
          @change="filesChange"
          placeholder="Select file"
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </base-input>

      <div class="lg:w-1/2 w-full md:w-1/2 lg:pl-3 md:pl-3">
        <base-button
          block
          class="mt-3 w-1/3"
          type="primary"
          @click="toggleDetails(true, item)"
          >Select Recipients</base-button
        >
      </div>
    </div>
    <base-button type="success">Submit</base-button>
  </div>
</template>
<script>
import TextEditor from "./TextEditor";
import SMSRecipientsPopup from "../../sms/components/SMSRecipientsPopup";
export default {
  data() {
    return {
      content: "",
      isDetailsActive: false,
    };
  },
  components: {
    TextEditor,
    SMSRecipientsPopup,
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
